import { EventListeners, EventPayloads, EventType } from "../helpers/types";

export class EventEmitter {
    private static listeners: EventListeners = {};

    static on<K extends EventType>(event: K, listener: (data: EventPayloads[K]) => void) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(listener);
    }

    static off<K extends EventType>(event: K, listener: (data: EventPayloads[K]) => void) {
        const existing = this.listeners[event];
        if (!existing) return;

        const index = existing.indexOf(listener);
        if (index !== -1) existing.splice(index, 1);
    }

    static emit<K extends EventType>(event: K, data: EventPayloads[K]) {
        const listeners = this.listeners[event];
        if (!listeners) return;
        for (const listener of listeners) {
            listener(data);
        }
    }
}
